import * as React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import {
  Duration,
  TechSelect,
  DateRangePicker,
  TimeRangePicker,
  TechRegionSelect,
} from './FormFields'
import { useFormData } from './hooks'
import { ClearAllButton } from './ClearAllButton'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

type ContentProps = {
  isRescheduling: boolean
}

export function Content(props: ContentProps) {
  const { isRescheduling } = props
  const { techOptions, techRegionOptions, showNoResultsError } = useFormData()

  const renderTechRegions = techRegionOptions.length > 0

  return (
    <Grid container spacing={2} px={2}>
      {showNoResultsError && (
        <Grid item xs={12}>
          <Alert
            sx={{
              display: 'flex',
              alignItems: 'start',
            }}
            severity="error"
          >
            <AlertTitle>
              <Typography
                variant="subtitle1"
                sx={{
                  lineHeight: '24px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
                color="#541313"
              >
                No results found
              </Typography>
            </AlertTitle>

            <Typography variant="body2">
              Refine search to find available times
            </Typography>
          </Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="subtitle3">Select Filters</Typography>
          <ClearAllButton />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <DateRangePicker />
      </Grid>

      <Grid item xs={12}>
        <TimeRangePicker />
      </Grid>

      {!isRescheduling && (
        <Grid item xs={12}>
          <Duration />
        </Grid>
      )}

      {renderTechRegions && (
        <Grid item xs={12}>
          <TechRegionSelect techRegionOptions={techRegionOptions} />
        </Grid>
      )}

      <Grid item xs={12}>
        <TechSelect techOptions={techOptions} />
      </Grid>
    </Grid>
  )
}
